exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (max-width: 575px) {\n.mail-confirm-br[data-v-888bfbd8] {\n        display: none;\n}\n}\n", ""]);

// exports
